var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0V16H0V0H16ZM13.3516 5.35156L12.6484 4.64844L6 11.2891L3.35156 8.64844L2.64844 9.35156L6 12.7109L13.3516 5.35156Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedDisabledIcon);
export default __webpack_public_path__ + "static/media/checkedDisabledIcon.d15a856a77343c5bde11279a35df8adf.svg";
export { ForwardRef as ReactComponent };